<!-- title -->
<app-modal-title
  [title]="'pages.pollParsers.selectOption' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div
  mat-dialog-content
  class="dialog-content tw-text-xl tw-text-center tw-mb-1"
>
  <div class="tw-w-[400px] tw-pb-5">
    <div
      class="alert alert-primary senders-list tw-text-right tw-mb-5 tw-pb-3"
      [innerHtml]="'messages.sendersListAlert' | translate"
    ></div>

    <div>
      <div class="row tw-mt-3 tw-mb-5">
        <div
          class="tw-w-1/2 tw-flex tw-py-2 tw-pr-[15px] ltr:tw-pl-[15px]"
          *ngFor="let item of pollParserFormula; let i = index"
        >
          <mat-slide-toggle
            [checked]="isChecked[i]"
            (change)="changePollParserFormula(item.keyword, i)"
          >
            <app-expand-text [placement]="'right'">
              <span small-text>
                <span>
                  <i
                    class="mdi mdi-check-bold text-success mdi-18px"
                    *ngIf="item.isCorrect"
                  ></i>
                  <i
                    class="mdi mdi-close-thick text-danger mdi-18px"
                    *ngIf="!item.isCorrect"
                  ></i>
                </span>
                {{ item.keyword }}
              </span>
              <div full-text class="full-text-display">
                <span>
                  <i
                    class="mdi mdi-check-bold text-success mdi-18px"
                    *ngIf="item.isCorrect"
                  ></i>
                  <i
                    class="mdi mdi-close-thick text-danger mdi-18px"
                    *ngIf="!item.isCorrect"
                  ></i>
                </span>
                {{ item.keyword }}
              </div>
            </app-expand-text>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <!-- form btns-->
  <div>
    <app-form-btns
      [customTitle]="'common.nextStep' | translate"
      [loading]="false"
      [isEdit]="false"
      (onClose)="onClose()"
      (onSubmit)="onConfirm()"
    >
    </app-form-btns>
  </div>
</div>
